import {
  ConditionType,
  DeviceAttributeRow as SharedDeviceAttributeRow,
  PEOPLE_ATTRIBUTE_FIELD_POLICY,
  PEOPLE_SEARCH_OPERATOR_FAMILIES,
} from '@/features/dryad';
import { ConditionTypeSelect } from './condition-type-select';

type DeviceAttributeRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared device-attribute row. */
export function DeviceAttributeRow({ id }: DeviceAttributeRowProps) {
  return (
    <SharedDeviceAttributeRow
      id={id}
      conditionType={ConditionType.DeviceAttribute}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.DeviceAttribute} />}
      operatorFamilies={PEOPLE_SEARCH_OPERATOR_FAMILIES}
      fieldPolicy={PEOPLE_ATTRIBUTE_FIELD_POLICY}
    />
  );
}
